import { get } from './client';

export function searchSeedCatalog(crop, searchTerm, year) {
  return get('/product-catalog/seeds', { params: { crop, searchTerm, year } });
}

export function getUnifiedSeeds(searchTerm, crop, year, limit = 100) {
  return get('/product-catalog/unified-seeds', {
    params: { searchTerm, crop, limit, year },
  });
}

export function getCompassProduct(id) {
  return get(`/product-catalog/compass-product/${encodeURIComponent(id)}`);
}
